<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "workList-managing"
    }
</script>

<style lang="less" scoped>

</style>